import { render, staticRenderFns } from "./SearchUserAssetHeader.vue?vue&type=template&id=1ab91320&"
import script from "./SearchUserAssetHeader.vue?vue&type=script&lang=js&"
export * from "./SearchUserAssetHeader.vue?vue&type=script&lang=js&"
import style0 from "./SearchUserAssetHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports